
import { concatMap } from '../../../../../methods';

export const getActiveFilters = ({ filterGroups }) => {
    return concatMap(
        filterGroups.filter(filterGroup => {
            if (filterGroup) {
                return filterGroup.inputType === 'checkbox' ||
                filterGroup.inputType === 'toggle-switch' ||
                filterGroup.inputType === 'radio' ||
                filterGroup.inputType === 'increment' ||
                filterGroup.inputType === 'dropdown';
            }
        }), filterGroup =>
            filterGroup.filters.filter(filter => {
                if (filter.data.type === 'number') {
                    return filter.data.value > 0;
                } else if (filterGroup.inputType === 'dropdown') {
                    return filter.data.value !== filter.data.default;
                }
                return filter.data.value;
            })
    ).length;
};



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/methods/index.js